import {
    createRouter,
    createWebHistory
} from 'vue-router'
const routes = [{
    path: '/',
    redirect: '/index'
}, {
    path: '/index',
    component: () => import('../views/index.vue'),
    meta: {
        title: '关于长勤'
    }
}, ]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})
router.beforeEach((to, form, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next()
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        location.reload();
    }
});
export default router